import { Pipe, PipeTransform } from '@angular/core';
import { CalendarLeaveType, LEAVE_TYPE_ICONS, VacationType } from 'src/app/shared/constants';

@Pipe({
  name: 'vacationTypeToIcon',
})
export class VacationTypeToIconPipe implements PipeTransform {
  transform(value: VacationType | CalendarLeaveType): string {
    return LEAVE_TYPE_ICONS[value] ?? 'event';
  }
}
